import { render, staticRenderFns } from "./TCControlsTray.vue?vue&type=template&id=3ec625b3&scoped=true"
import script from "./TCControlsTray.vue?vue&type=script&lang=js"
export * from "./TCControlsTray.vue?vue&type=script&lang=js"
import style0 from "./TCControlsTray.vue?vue&type=style&index=0&id=3ec625b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec625b3",
  null
  
)

export default component.exports